import React, { useRef, useState } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import JoditEditor from "jodit-react";

function CreatePage() {
  const editor = useRef(null);
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [formdata, setFormdata] = useState({
    title: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/page/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formdata),
        }
      );

      let data;
      try {
        data = await response.json();
      } catch {
        data = {
          message: response.statusText || "Unexpected response from server",
        };
      }

      if (response.ok) {
        toast.success("Page added successfully!");
        setFormdata({ title: "", description: "" });
      } else {
        toast.error(data.message || "Failed to add page");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Pages</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Add Page</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-12">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Title Name"
                    name="title"
                    value={formdata.title}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Page Name</label>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-control mb-3">
                  <label htmlFor="floatingTextarea">Description</label>
                  <JoditEditor
                    className="mt-2"
                    ref={editor}
                    value={formdata.description}
                    onChange={(content) =>
                      setFormdata({ ...formdata, description: content })
                    }
                  />
                </div>
              </div>

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Page"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default CreatePage;
